module.exports = __webpack_public_path__ + "img/AdminConfig.63763554.svg";